const Content = ({ children, small = false }) => {
    return (
        small ? (
            <div className="wide-content mx-auto">
                {children}
            </div>
        )
            :
            (
                <div className="wide-content mx-auto">
                    {children}
                </div>
            )
    );
};

export default Content;